import { defineComponent } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { ExamService } from '@/services/exam/exam.service';
import { value2label, QUESTION_TYPE, IS_QUESTION_TYPE_PROGRAM } from '@/utils';
export default defineComponent({
  name: 'QuestionMenu',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectQuestion: {
      type: Function,
      required: true
    }
  },
  setup: function setup() {
    var examService = useService(ExamService);
    return {
      examService: examService,
      value2label: value2label,
      QUESTION_TYPE: QUESTION_TYPE,
      IS_QUESTION_TYPE_PROGRAM: IS_QUESTION_TYPE_PROGRAM
    };
  }
});